/** 16px body copy with consistent 1.5 line-height (text-body token). */
export const bodyTextClass = "font-sans text-body";

/** Markdown / rich text body with list and link styles. */
export const bodyProseClass =
  "font-sans text-body [&_a]:text-link [&_li]:mt-0 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-0 [&_ul]:list-disc [&_ul]:pl-6";

/** Markdown body with spacing between paragraphs. */
export const bodyProseSpacedClass =
  "font-sans text-body [&_a]:text-link [&_h2]:mt-0 [&_h2]:font-display [&_h2]:text-heading-2-sm md:[&_h2]:text-heading-2 [&_h2]:font-bold [&_h2]:leading-[1.2] [&_h3]:mt-0 [&_h3]:font-sans [&_h3]:text-heading-3 [&_h3]:font-semibold [&_h4]:mt-0 [&_li]:mt-0 [&_ol]:list-decimal [&_ol]:pl-6 [&_p+p]:mt-6 [&_ul]:list-disc [&_ul]:pl-6";
